import OneBoxPage from "./components/page";
import { createElement } from "react";
import { HANDLERS } from "./config";

const initService = ({ registerAction, createExtension }: any) => {
    const pages = createExtension.sync(HANDLERS.ONE_BOX_PAGE).map(($: any) => $[0]);
    pages.forEach(({ title, element, component, props, ...route }: any) =>
        registerAction({
            target: "$ONE_LAYOUT_ROUTE",
            handler: {
                ...route,
                element: (
                    <OneBoxPage
                        title={title}
                        {...props}
                    >
                        {element || createElement(component, props)}
                    </OneBoxPage>
                ),
            },
        }),
    );
};

export default initService;
